// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Chart } from 'chart.js';

@Injectable()
export class ChartjsExtensionService {
  addSpyLineChartDefinition(): void {
    function extendChart() {
      Chart.defaults.SpyLine = Chart.defaults.line;
      Chart.controllers.SpyLine = Chart.controllers.line.extend({
        draw: function (ease) {
          Chart.controllers.line.prototype.draw.call(this, ease);

          const ctx = this.chart.ctx;

          if (this.chart.percentageChangeTooltip?._active && this.chart.percentageChangeTooltip?._active.length) {
            const activePoint = this.chart.percentageChangeTooltip._active[0];
            const x = activePoint.tooltipPosition().x;
            const topY = this.chart.scales['y-axis-0'].top;
            const bottomY = this.chart.scales['y-axis-0'].bottom;

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 0.3;
            ctx.strokeStyle = '#ffffff';
            ctx.stroke();
            ctx.restore();
          }
        },
      });
    }

    extendChart();
  }
}
